import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "../../../components/layout/Layout";

export default function EditBanner() {
  const [formData, setFormData] = useState({
    title: "",
    image: null,
    categoryId: "",
  });
  const [data, setData] = useState([]);
  const [disableBtn, setDisableBtn] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const navigate = useNavigate();
  const { bannerId } = useParams();
  const location = useLocation();
  const data1 = location?.state?.data;

  useEffect(() => {
    getProductCategories();
    if (data1) {
      setFormData({
        title: data1.title || "",
        image: null,
        categoryId: data1.categoryId || "",
      });

      // Convert local path to valid URL (adjust BASE_URL if needed)
      const baseUrl = process.env.REACT_APP_MEDIA_BASE_URL || "http://localhost:5000";
      const rawPath = data1.imageUrl?.[0] || "";
      const cleanedPath = rawPath.replace(/\\/g, "/").replace(/^public\//, "");
      setPreviewImage(`${baseUrl}/public/${cleanedPath}`);
    }
  }, [data1]);

  const getProductCategories = async () => {
    try {
      const token = localStorage.getItem("sansadToken");
      const headers = {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/category/view-all-categories?status=Active&page=1&limit=100`,
        { headers }
      );
      if (response.data.statusCode === 200) {
        setData(response.data.result.categories);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Category fetch error:", error);
    }
  };

  const handleInputChange = (e) => {
    const { name, files, value } = e.target;
    if (name === "image") {
      const file = files[0];
      setFormData((prev) => ({ ...prev, image: file }));
      setPreviewImage(URL.createObjectURL(file));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisableBtn(true);

    try {
      const headers = {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("sansadToken")}`,
      };

      const formdata = new FormData();
      formdata.append("bannerId", bannerId);
      if (formData.title) formdata.append("title", formData.title);
      if (formData.categoryId) formdata.append("categoryId", formData.categoryId);
      if (formData.image) formdata.append("image", formData.image);

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/banner/edit-banner`,
        formdata,
        { headers }
      );

      if (response.data.statuscode === 200) {
        toast.success(response.data.message);
        navigate(-1); // Go back
      } else {
        toast.error(response.data.message || "Something went wrong.");
      }
    } catch (error) {
      console.error("Submit error:", error);
      toast.error("Failed to update banner. Please try again.");
    }

    setDisableBtn(false);
  };

  return (
    <Layout>
      <ToastContainer />
      <div className="bg-white md:p-10 p-3 rounded-xl shadow-md mt-8 tracking-wide">
        <div className="flex justify-between items-center">
          <h2 className="text-xl font-medium">Edit Banner</h2>
        </div>
        <div className="mt-10">
          <form onSubmit={handleSubmit}>
            {/* Title */}
            <div>
              <label className="text-sm">Title</label>
              <input
                type="text"
                name="title"
                value={formData.title}
                onChange={handleInputChange}
                className="border border-black h-[40px] px-3 w-full mt-2 rounded-sm text-sm capitalize"
                required
              />
            </div>

            {/* Category */}
            <div className="mt-4">
              <label className="text-sm">Select Category</label>
              <select
                name="categoryId"
                value={formData.categoryId}
                onChange={handleInputChange}
                className="border border-black h-[40px] px-3 w-full mt-2 rounded-sm text-sm capitalize"
              >
                <option value="">Select Category</option>
                {data.map((item) => (
                  <option value={item._id} key={item._id}>
                    {item.title}
                  </option>
                ))}
                <option value="123456789">Home Banner</option>
              </select>
            </div>

            {/* Image */}
            <div className="mt-4">
              <label className="text-sm">Banner Image</label>
              <input
                type="file"
                name="image"
                accept="image/*"
                onChange={handleInputChange}
                className="block w-full text-sm file:mr-4 file:px-6 file:py-2 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-slate-100 file:text-[#ff4141] cursor-pointer mt-2"
              />
              {previewImage && (
                <img
                  src={previewImage}
                  alt="Preview"
                  className="mt-4 w-40 h-auto rounded"
                />
              )}
            </div>

            {/* Submit */}
            <div className="mt-8 text-end">
              <button
                type="submit"
                className="bg-[#2c2c38] text-white h-[40px] px-8 rounded-md text-sm hover:bg-[#191919]"
                disabled={disableBtn}
              >
                {disableBtn ? "Updating..." : "Update Banner"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </Layout>
  );
}
